module.exports = __webpack_public_path__ + "img/defImg.f9092e22.png";